import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTopButton from '@/components/feature/ScrollToTopButton';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryNav from './components/CategoryNav';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/articles';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://yuanfeel.github.io',
    description: siteInfo.description,
    inLanguage: 'zh-CN',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'https://yuanfeel.github.io',
    description: siteInfo.description,
    foundingDate: siteInfo.foundingYear,
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: siteInfo.fullName,
    description: siteInfo.description,
    url: 'https://yuanfeel.github.io',
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <Navbar />
      <ScrollToTop />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryNav />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTopButton />
    </>
  );
}